import { createPopper } from '@popperjs/core';
import bootstrap from 'bootstrap';
import AOS from 'aos';
import Flickity from 'flickity';
import mixitup from 'mixitup';
import SlimSelect from 'slim-select'
import './mapplic/jquery.mousewheel.js'
import * as Mapplic from './mapplic/mapplic.js'

$ = window.$ = window.jQuery = require('jquery');

$(document).ready(function () {
	
	var map = $('#mapplic').mapplic({
		source: '/map-data.json',
		iconfile: '/dist/img/mapplic/icons.svg',
		minimap: false,
		sidebar: false,
		searchdescription: true,
		searcheverywhere: true,
		hovertip: true,
		hovertipdesc: true,
		autopopulate: true,
		deeplinking: true,
		animations: true,
		marker: 'hidden',
		moretext: 'View store details',
		zoom:3
	});
	
	// Access to map object from selector
	var mapAPI = map.data('mapplic');
	// $(document).on('click', '#goto-level-button', function(e) {
	// 	e.preventDefault();
	// 	map.switchLevel('level2');
	// });
	$('.level-switcher .btn-level').on('click', function(){
		let level = $(this).data('level');
		$('.level-switcher .btn-level').removeClass('active');
		$(this).addClass('active');
		mapAPI.switchLevel(level);
		$('.mapplic-clear-button').click();
	});
	
	// Level switched
	map.on('levelswitched', function(e, level) {
		$('.level-switcher .btn-level').removeClass('active');
		$('.level-switcher [data-level="'+level+'"]').addClass('active');
	});
	
	// Location opened
	map.on('locationopened', function(e, location) {
		// location grants full access to the location
		$('.mapplic-dir-results').hide();
	});
	
	// Read a page's GET URL variables and return them as an associative array.
	function getUrlVars()
	{
		var vars = [], hash;
		var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
		for(var i = 0; i < hashes.length; i++)
		{
			hash = hashes[i].split('=');
			vars.push(hash[0]);
			vars[hash[0]] = hash[1];
		}
		return vars;
	}
	
	var location = getUrlVars()["location"];
	if (location) {
		$([document.documentElement, document.body]).animate({
			scrollTop: $("#map-controls").offset().top - 300
		}, 1000);
	}
	
	
	// Hide Header on on scroll down
	const body = document.body;
	const scrollUp = "scroll-up";
	const scrollDown = "scroll-down";
	let lastScroll = 0;

	window.addEventListener("scroll", () => {
		const currentScroll = window.pageYOffset;
		if (currentScroll <= 0) {
			body.classList.remove(scrollUp);
			return;
		}
		
		if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
			// down
			body.classList.remove(scrollUp);
			body.classList.add(scrollDown);
		} else if (
			currentScroll < lastScroll && body.classList.contains(scrollDown)) {
			// up
			body.classList.remove(scrollDown);
			body.classList.add(scrollUp);
		}
		lastScroll = currentScroll;
	});

	if($(window).scrollTop() > 1){
		body.classList.add(scrollDown);
	}

	//Navigation
	$('#toggle').click(function() {
	   $(this).toggleClass('active');
	   $('body').toggleClass('menu-open');
	});	
	$('.overlay-menu li:not(.menu-item-has-children) a').click(function() {
	   $('#toggle').removeClass('active');
	   $('body').removeClass('menu-open');
	});
	$('.overlay-menu li.menu-item-has-children a').click(function() {
		$('.sub-menu').removeClass('show');
		$(this).parent().find('.sub-menu').addClass('show');
	});
	$('#closeNav').click(function() {
	   $('#toggle').removeClass('active');
	   $('body').removeClass('menu-open');
	});
	var x = window.matchMedia("(max-width: 992px)");
	if (x.matches) {
		$('.menu-item-has-children').click(function(e) {
		    var $this = $(this),
		        clickNum = $this.data('clickNum');
		    if (!clickNum) clickNum = 1;
		    if (clickNum == 1){
		    	$(this).find('.sub-menu').addClass('show');
		   		e.preventDefault();
		   	}
		    $this.data('clickNum', ++clickNum);
		});
	}

	// Set all carousel items to the same height
    function carouselNormalization() {     
        window.heights = [], //create empty array to store height values
        window.tallest; //create variable to make note of the tallest slide
        function normalizeHeights() {
            $('.carousel .carousel-item ').each(function() { //add heights to array
                window.heights.push(jQuery(this).outerHeight());
            });
            window.tallest = Math.max.apply(null, window.heights); //cache largest value
            $('.carousel .carousel-item .row').each(function() {
                $(this).css('min-height',tallest + 'px');
            });
        }
        normalizeHeights();
        jQuery(window).on('resize orientationchange', function () {
            window.tallest = 0, window.heights.length = 0; //reset vars
            $('.carousel .carousel-item .row').each(function() {
                $(this).css('min-height','0'); //reset min-height
            }); 
            
            normalizeHeights(); //run it again 
        });
    }
    carouselNormalization();

    if(document.querySelector('.carousel-numbering') != null) {
    	var heroCarousel = document.getElementById('heroCarousel');
        var totalItems = $('.carousel-item').length;
        var currentIndex = $('.carousel-item.active').index() + 1;
        $('.carousel-numbering').html('' + currentIndex + '/' + totalItems + '');

        heroCarousel.addEventListener('slide.bs.carousel', function () {
          currentIndex = $('div.active').index() + 1;
          $('.carousel-numbering').html('' + currentIndex + '/' + totalItems + '');
        });
    }

    //Convert columns to carousel (Flickity) on mobile
    if(document.querySelector('.listings') != null) {
		var listingElems = document.querySelectorAll('.listings');

		for ( var i=0, len = listingElems.length; i < len; i++ ) {
		  var listingElem = listingElems[i];
		  new Flickity( listingElem, {
			cellSelector: '.col-md-3',
			prevNextButtons: false,
			fullscreen: true,
			watchCSS: true,
			adaptiveHeight: true
		  });
		}	
	}

	//Directory Filters
	if(document.querySelector('.directory') != null) {
		const mixer = mixitup( '.directory', function(){
	     	pagination: {
		        limit: 4
		    }
	    });
	    
	    $('.storesSearch').on('keyup', function(){
	        const searchValue = $(this).val().toLowerCase();
	        let keyupTimeout;
	        clearTimeout(keyupTimeout);
	        keyupTimeout = setTimeout(function() {
	            filterByString(searchValue);
	        }, 350);
	        function filterByString(searchValue) {
	          // mixer.filter('all');
	          if (searchValue) {
	            // Use an attribute wildcard selector to check for matches
	            mixer.filter('[data-title*="' + searchValue + '"]');
	          } else {
	            // If no searchValue, treat as filter('all')
	            mixer.filter('all');
	          }
	        }
	    });

	    var filterSelect = document.querySelector('#storesFilter');

		filterSelect.addEventListener('change', function() {
		    mixer.filter(filterSelect.value);
		});
		// Style select box
		new SlimSelect({
		  select: '#storesFilter',
		  showSearch: false,
		})
	}
	if(document.querySelector('#store-info') != null) {
		new SlimSelect({
		  select: '#hours-select',
		  showSearch: false,
		})
	}


	AOS.init();

});